import { render, staticRenderFns } from "./bookerAggregate.vue?vue&type=template&id=13ff9987&scoped=true&"
import script from "./bookerAggregate.vue?vue&type=script&lang=js&"
export * from "./bookerAggregate.vue?vue&type=script&lang=js&"
import style0 from "./bookerAggregate.vue?vue&type=style&index=0&id=13ff9987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff9987",
  null
  
)

export default component.exports